import { render, staticRenderFns } from "./ConfirmButton.vue?vue&type=template&id=6b2e6bb2&scoped=true&"
import script from "./ConfirmButton.vue?vue&type=script&lang=js&"
export * from "./ConfirmButton.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmButton.vue?vue&type=style&index=0&id=6b2e6bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2e6bb2",
  null
  
)

export default component.exports